import { render, staticRenderFns } from "./ShopUserLookRecordTable.vue?vue&type=template&id=6883037e&scoped=true&"
import script from "./ShopUserLookRecordTable.vue?vue&type=script&lang=js&"
export * from "./ShopUserLookRecordTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopUserLookRecordTable.vue?vue&type=style&index=0&id=6883037e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6883037e",
  null
  
)

export default component.exports